import VueGtag from 'vue-gtag'

export default ({ app, router }) => {
  if (process.env.NODE_ENV === 'development') {
    return
  }

  app.use(VueGtag, {
    appName: process.env.SITE_NAME,
    pageTrackerScreenviewEnabled: true,
    includes: [
      {
        // Google Tag Manager
        id: 'GTM-58L328CP'
      }
    ],
    config: {
      // Google Analytics
      id: 'G-33374SRRF4'
    },
    onReady () {
      app.config.errorHandler = function (err, vm) {
        console.error(err)
        console.error(vm)
        app.config.globalProperties.$gtag.exception({
          'description': err.stack,
          'fatal': true
        })
        return false
      }

      window.onerror = function (message, source, lineno, colno, error) {
        if (error) message = error.stack
        app.config.globalProperties.$gtag.exception({
          'description': message,
          'fatal': false
        })
        return false
      }

      router.afterEach((to, from) => {
        app.config.globalProperties.$gtag.pageview({
          page_path: to.matched[to.matched.length - 1].path, // generic route path (/clients:id? etc, instead of /clients/69)
          page_title: to.name
        })
      })
    }
  }, router)
}
